<template>
  <launch-game
    :games="games"
    :countries="countries"
    :loading-games="loadingGames"
    @project-selected="loadGames"
    @project-provider-selected="loadProxyCountries"
    :loading-proxy-countires="loadingProxyCountries"
    @launch-game="onLaunchGame"
  />
</template>

<script>
  import { API } from '@/utils/api'
  import LaunchGame from '../components/LaunchGame.vue'
  import { countriesToFullNamesMap } from '@/components/core/SelectLang/mapperIsoLocale'
  import { map, uniq, flatten, chain } from 'lodash'

  export default {
    components: {
      LaunchGame,
    },

    data () {
      return {
        isLoading: false,
        games: [],
        countries: [],
        loadingGames: false,
        loadingProxyCountries: false,
      }
    },

    methods: {
      loadProxyCountries ({ entity_id, system_id, brand_id }) {
        this.loadingProxyCountries = true

        if (!(entity_id && system_id && brand_id)) {
          this.countries = []
          return
        }

        return API.call('/$v/proxer/access/get_by_provider.json', {
          entity_id,
          system_id,
          brand_id
        })
          .then(result => {
            const uniqueCountries = this.extractUniqueCountries(result.data.proxers)
            this.countries = this.formatCountries(uniqueCountries)
          })
          .catch(error => {
            console.error('Error loading proxers:', error)
            return []
          })
          .finally(() => {
            this.loadingProxyCountries = false
          })
      },
      loadGames (project) {
        this.loadingGames = true

        return API.call('/$v/game/list.json', {}, null, project)
          .then(resp => {
            this.games = resp.data
          })
          .catch(e => {
            console.error('Error loading games:', e)
          })
          .finally(() => {
            this.loadingGames = false
          })
      },

      onLaunchGame (launchData) {
        this.isLoading = true
      },

      extractUniqueCountries (proxers) {
        return chain(proxers)
          .map('countries')
          .flatten()
          .filter(Boolean)
          .uniq()
          .value()
      },

      formatCountries (countryCodes) {
        return map(countryCodes, countryCode => {
          const formattedValue = countryCode.toUpperCase()
          return {
            value: formattedValue,
            text: formattedValue,
            fullName: countriesToFullNamesMap[countryCode.toLowerCase()] || countryCode
          }
        })
      }
    }
  }
</script>
